module.exports = __webpack_public_path__ + "img/1480286984.3fd3a6c0.jpg";